<template>
    <div class="exam-result-management">
        <h3>시스템 설정 > 장비 관리 > 상세</h3>
        <div>
        <!-- 최상단 오른쪽 '기기 삭제' 버튼 -->
        <div class="erm-action-btns" v-if="device.id">
            <button type="button" class="dev-del-btn" @click="deleteDevice">기기 삭제</button>
        </div>
        <div class="dev-card-box">
            <label class="firm-label">기기정보</label>
            <!-- 정보 입력 구역 -->
            <div class="section dev-info-section">
                <div class="info-group">
                    <label class="dev-label" for="model">모델명</label>
                    <select id="model" v-model="device.model" class="dev-select">
                        <option value="P-Sense">P-Sense</option>
                        <!-- 필요시 추가 옵션 -->
                    </select>
                </div>
                <div class="info-group">
                    <label class="dev-label" for="serial">시리얼 번호</label>
                    <input id="serial" v-model="device.serial" class="dev-input" :readonly="!isEditingSerial"/>
                    <button class="dev-mid-btn" @click="toggleEditDevice('serial')">
                        {{ isEditingSerial ? '수정중' : '수정' }}
                    </button>
                </div>

                <div class="info-group">
                    <label class="dev-label" for="name">장비 별칭</label>
                    <input id="name" v-model="device.name" class="dev-input" :readonly="!isEditingName"/>
                    <button class="dev-mid-btn" @click="toggleEditDevice('name')">
                        {{ isEditingName ? '수정중' : '수정' }}
                    </button>
                </div>
            </div>
        </div>

            <div class="dev-card-box">
                <!-- 하부 상태 영역 -->
                <div class="firm-label">연결 상태</div>
                <div class="info-group">
                    <div class="dev-label">연결 상태</div>
                    <div class="state-val">
                    <span
                        class="status-dot"
                        :class="device.status === '0' ? 'connected' : (device.status === '1' ? 'disconnected' : '')">
                    </span>
                        {{ device.status === '0' ? '연결됨' : (device.status === '1' ? '신호 없음' : '알 수 없음') }}
                    </div>

                </div>
            </div>

        <div class="dev-card-box">
            <div class="section">
                <div class="firm-label">펌웨어</div>
                <div class="info-group">
                    <div class="dev-label">버전</div>
                    <div class="firm-val">
                        <span class="firm-version"><b>{{ device.firmware }}</b></span>
                        <span v-if="device.update_needed" class="erm-update-needed">업데이트 필요</span>
                        <button class="dev-mid-btn" @click="firmwareUpdate">업데이트</button>
                    </div>
                </div>
            </div>
        </div>

            <!-- 하단 버튼 -->
            <div class="btn-row">
                <button class="dev-save-btn" @click="deviceSave">저장</button>
            </div>
        </div>
    </div>

</template>

<script>
import api, {urls} from "@/api";

export default {
    name: 'DeviceDetails',
    data() {
        return {
            device: {
                model: 'P-Sense',
                serial: '',
                name: '',
                status:'',
                firmware: '',
                last_fw_update: null,
                update_needed: 0,
            },
            isEditMode: false,
            isEditingSerial: false,
            isEditingName: false,
        };
    },
    methods: {

        validateForm() {
            if (!this.device.model || this.device.model.trim() === '') {
                alert("모델명을 선택해주세요.");
                return false;
            }
            if (!this.device.serial || this.device.serial.trim() === '') {
                alert("시리얼 번호가 없습니다.");
                return false;
            }
            if (!this.device.name || this.device.name.trim() === '') {
                alert("장비 별칭을 입력해주세요.");
                return false;
            }
            // 펌웨어 버전은 필요에 따라 유효성 검사 추가 가능
            return true;
        },

        deviceSearch(id){
            api.post(urls.system.deviceSearch, { id })
                .then(res => {
                    const data = res.data.list && res.data.list[0]
                    if (data) {
                        this.device.id = data.id;
                        this.device.model = data.modelName || '';         // 모델명
                        this.device.serial = data.serialNumber || '';     // 시리얼 번호
                        this.device.name = data.deviceName || '';         // 장비 별칭 (API에서 별칭이 없으면 deviceName 사용)
                        this.device.firmware = data.firmwareVersion || ''; // 펌웨어 버전
                        this.device.status = String(data.status);
                        this.device.update_needed = data.updateNeeded || null;
                    }
                })
                .catch(e => {
                    alert('계정 정보 불러오기에 실패했습니다.')
                    console.error(e)
                })
        },

        deviceSave() {
            if (!this.validateForm()) return;
            // API 주소 분기 (실제로 쓰는 주소에 맞게 변경)
            const url = this.isEditMode
                ? urls.system.deviceModify   // 수정 API
                : urls.system.deviceRegister // 등록 API

            api.post(url, this.device)
                .then(res => {
                    if (res.data === 1) {
                        alert(this.isEditMode ? '장비 수정이 완료되었습니다.' : '장비 등록이 완료되었습니다.');
                        this.goList();
                    } else {
                        alert(res.data.message || (this.isEditMode ? '장비 수정에 실패했습니다.' : '장비 등록에 실패했습니다.'));
                    }
                })
                .catch(e => {
                    alert(this.isEditMode ? '장비 수정 처리 중 오류가 발생했습니다.' : '장비 등록 처리 중 오류가 발생했습니다.');
                    console.error(e);
                });
        },
        deleteDevice() {
            api.post(urls.system.deviceDelete, { idList: [String(this.device.id)] })
                .then(res => {
                    const resInfo = res.data;
                    if (resInfo === 1) {
                        alert('장비 삭제에 성공했습니다.');
                        this.goList();
                    } else {
                        this.error = resInfo.message || '장비 삭제에 실패하였습니다.';
                        alert(this.error);
                    }
                })
                .catch(error => {
                    this.error = '장비 삭제기능이 실패했습니다.';
                    alert(this.error);
                });
        },

        firmwareUpdate(){
            alert('업데이트에 성공했습니다.(기능 미구현)');
        },

        goList() {
            this.$router.push('/DeviceManagement');  // 장비 목록 페이지 경로에 맞게 수정
        },

        toggleEditDevice(field) {
            if (field === 'serial' && !this.isEditingSerial) {
                this.isEditingSerial = true;
            } else if (field === 'name' && !this.isEditingName) {
                this.isEditingName = true;
            }
        },


    },
    mounted() {
        const id = this.$route.query.id;
        if (id !== undefined) {
            this.isEditMode = true;
            this.deviceSearch(id);
        } else {
            this.isEditMode = false;

        }
    }

};
</script>


